import type { FlowState } from './flowTypes'

export function flowStrokeColor(state: FlowState, isolating: boolean): string {
  if (state === 'unknown') return 'var(--muted-foreground)'
  if (isolating)
    return state === 'blocked'
      ? 'var(--pnid-isolation-safe)'
      : 'var(--pnid-isolation-energized)'
  return state === 'blocked' ? 'var(--destructive)' : 'var(--pnid-flow)'
}
